import { render, staticRenderFns } from "./GDuplicateNameDifferencesTable.vue?vue&type=template&id=35694787&scoped=true&"
import script from "./GDuplicateNameDifferencesTable.vue?vue&type=script&lang=ts&"
export * from "./GDuplicateNameDifferencesTable.vue?vue&type=script&lang=ts&"
import style0 from "./GDuplicateNameDifferencesTable.vue?vue&type=style&index=0&id=35694787&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35694787",
  null
  
)

export default component.exports